export default "__VITE_ASSET__BMW0qOCG__"